module.exports = __webpack_public_path__ + "static/three-336c0f5d5937d8b05c33b64946a735c4.png";